// Size Converter Script
// Externalized for better performance and browser cache
(function () {
  // Get data from inline JSON
  const sizeConverterData = document.getElementById('size-converter-data');
  if (!sizeConverterData) return;
  
  let config;
  try {
    config = JSON.parse(sizeConverterData.textContent);
  } catch (e) {
    return;
  }
  
  const marketHandle = config.market;
  const countryName = config.country;
  const isCalzado = config.isCalzado;
  
  if (isCalzado) return;
  
  const MAPS = {
    uk: { 32: '4', 34: '6', 36: '8', 38: '10', 40: '12', 42: '14', 44: '16', 46: '18', 48: '20', 50: '22' },
    italia: {
      32: '36',
      34: '38',
      36: '40',
      38: '42',
      40: '44',
      42: '46',
      44: '48',
      46: '50',
      48: '52',
      50: '54',
    },
    eu: {
      32: '30',
      34: '32',
      36: '34',
      38: '36',
      40: '38',
      42: '40',
      44: '42',
      46: '44',
      48: '46',
      50: '48',
    },
    usmx: { 32: '0', 34: '2', 36: '4', 38: '6', 40: '8', 42: '10', 44: '12', 46: '14', 48: '16', 50: '18' },
  };

  const ALIASES = {
    'estados-unidos': 'usmx',
    usa: 'usmx',
    mexico: 'usmx',
    alemania: 'eu',
    belgica: 'eu',
    irlanda: 'eu',
    luxemburgo: 'eu',
    'paises-bajos': 'eu',
    portugal: 'eu',
    suecia: 'eu',
  };

  let market = marketHandle ? marketHandle.toLowerCase() : '';
  market = ALIASES[market] || market;
  const map = MAPS[market];
  if (!map) return;

  const VARIANT_SELECTOR =
    '.block-swatch span, .line-item-info .smallcaps, .shopify-product-form .variant-item';
  const stickyOptionsSelector = '.sticky-variant-select option';
  const STATIC_ROOTS = '.accordion__content.prose, .product__description, .rte';

  const reVariant = /(.*)\(\s*(\d+)[\/-](\d+)\s*\)/;
  const reCountry = /\(\s*[A-Z]{2,}(?:\/[A-Z]{2,})?\s*\)/g;
  const sourceSizes = Object.keys(map);
  const sizeRegex = new RegExp(`\\b(?:${sourceSizes.join('|')})\\b`, 'g');

  const wrapNum = (n) => `<span data-wg-notranslate translate="no" class="wg-notranslate">${n}</span>`;

  function fixSpaces(str) {
    return str.replace(/(\S)\(/g, '$1 (');
  }

  function forceInlineDisplay(scope) {
    scope
      .querySelectorAll('.product-info__block-item .accordion__content span[data-wg-notranslate]')
      .forEach((s) => {
        s.style.display = 'inline';
      });
    scope
      .querySelectorAll('.product-info__block-item .accordion__content span[data-size-wrapper="1"]')
      .forEach((s) => {
        s.style.display = 'inline';
      });
  }
  const SCOPE_SELECTOR = '.product-info__block-item .accordion__content';
  (function injectInlineRuleOnce() {
    if (document.getElementById('sizeconv-inline-rule')) return;
    const style = document.createElement('style');
    style.id = 'sizeconv-inline-rule';
    style.textContent = `${SCOPE_SELECTOR} span{display:inline !important;}`;
    document.head.appendChild(style);
  })();

  function remapVariant(el) {
    if (el.dataset.sizeMapped) return;
    const txt = el.textContent.trim();
    const m = txt.match(reVariant);
    if (!m) return;
    const [, label, low, high] = m;
    const r0 = map[low],
      r1 = map[high];
    if (!r0 || !r1) return;
    let html = `${label.trim()} (${wrapNum(r0)}-${wrapNum(r1)})`;
    html = html.replace(
      reCountry,
      `<span class="wg-translate-country" style="display:inline">(${countryName})</span>`
    );
    html = fixSpaces(html);
    el.innerHTML = html;
    const scope = el.closest('.product-info__block-item .accordion__content') || el;
    if (window.Weglot && typeof Weglot.refresh === 'function') Weglot.refresh(scope);
    forceInlineDisplay(el);
    el.dataset.sizeMapped = '1';
  }

  function remapVariantOption(el) {
    if (el.dataset.sizeMapped) return;

    const original = el.textContent;
    const parts = original.split(' - ');
    const base = parts[0].trim();
    const suffix = parts.length > 1 ? ' - ' + parts.slice(1).join(' - ') : '';

    const m = base.match(reVariant);
    if (!m) return;

    const [, label, low, high] = m;
    const r0 = map[low], r1 = map[high];
    if (!r0 || !r1) return;

    el.textContent = `${label.trim()} (${r0}-${r1})${suffix}`;
    el.dataset.sizeMapped = '1';
  }

  function remapStatic(root) {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          if (!node.nodeValue || !sizeRegex.test(node.nodeValue)) return NodeFilter.FILTER_REJECT;
          const p = node.parentElement;
          if (!p) return NodeFilter.FILTER_REJECT;
          const tag = p.tagName;
          if (/(SCRIPT|STYLE|TEXTAREA|INPUT|SELECT|OPTION)/.test(tag)) return NodeFilter.FILTER_REJECT;
          if (p.closest('[data-wg-notranslate]')) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        },
      },
      false
    );

    const toProcess = [];
    let n;
    while ((n = walker.nextNode())) {
      toProcess.push(n);
    }

    toProcess.forEach((node) => {
      const original = node.nodeValue;
      let replaced = original.replace(sizeRegex, (m) => wrapNum(map[m] || m));
      replaced = replaced.replace(
        reCountry,
        `<span class="wg-translate-country" style="display:inline">(${countryName})</span>`
      );
      replaced = fixSpaces(replaced);
      if (replaced === original) return;

      const span = document.createElement('span');
      span.innerHTML = replaced;
      span.setAttribute('data-size-wrapper', '1');
      span.style.display = 'inline';
      span.querySelectorAll('span[data-wg-notranslate]').forEach((s) => {
        s.style.display = 'inline';
      });
      node.parentNode.replaceChild(span, node);
      const scope = span.closest('.product-info__block-item .accordion__content') || span;
      if (window.Weglot && typeof Weglot.refresh === 'function') Weglot.refresh(scope);
    });
  }

  function scan() {
    document.querySelectorAll(VARIANT_SELECTOR).forEach(remapVariant);
    document.querySelectorAll(STATIC_ROOTS).forEach(remapStatic);
    document.querySelectorAll(stickyOptionsSelector).forEach(remapVariantOption);
  }

  function refreshAfterCartUpdate() {
    // Cart drawer updates can happen outside current observed containers.
    // Re-scan and rebind observers after the DOM replacement finishes.
    setTimeout(() => {
      scan();
      setupObservers();
    }, 0);
    setTimeout(() => {
      scan();
      setupObservers();
    }, 120);
  }

  // Debounce to reduce frequent executions
  let scanTimeout;
  function debouncedScan() {
    clearTimeout(scanTimeout);
    scanTimeout = setTimeout(scan, 100);
  }

  // Observe only relevant containers instead of entire document.body
  const observeTargets = [];
  
  // Function to find and observe relevant containers
  function setupObservers() {
    // Clear previous observers
    observeTargets.forEach(obs => obs.disconnect());
    observeTargets.length = 0;
    
    // Find containers that may contain elements to be converted
    const mainContent = document.querySelector('main');
    const productInfo = document.querySelector('.product-info__block-item');
    const cartItems = document.querySelector('.cart-items, .line-items');
    const productForm = document.querySelector('.shopify-product-form');
    
    const targets = [mainContent, productInfo, cartItems, productForm].filter(Boolean);
    
    // If specific containers not found, use body but with reduced scope
    const finalTarget = targets.length > 0 ? targets : [document.body];
    
    finalTarget.forEach(target => {
      const observer = new MutationObserver(debouncedScan);
      observer.observe(target, {
        childList: true,
        subtree: true,
        characterData: true,
      });
      observeTargets.push(observer);
    });
  }

  // Initialize observers after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      scan();
      setupObservers();
    });
  } else {
    scan();
    setupObservers();
  }

  document.addEventListener('cart:change', refreshAfterCartUpdate);
  document.addEventListener('cart-drawer:refreshed', refreshAfterCartUpdate);
  document.addEventListener('cart:refresh', refreshAfterCartUpdate);

  // Re-scan when Weglot initializes
  if (window.Weglot && typeof Weglot.on === 'function') {
    Weglot.on('initialized', function() {
      scan();
      setupObservers();
    });
    Weglot.on('languageChanged', scan);
  } else {
    // Wait for Weglot if not yet available
    const checkWeglot = setInterval(function() {
      if (window.Weglot && typeof Weglot.on === 'function') {
        clearInterval(checkWeglot);
        Weglot.on('initialized', function() {
          scan();
          setupObservers();
        });
        Weglot.on('languageChanged', scan);
      }
    }, 100);
    
    // Stop checking after 5 seconds
    setTimeout(function() {
      clearInterval(checkWeglot);
    }, 5000);
  }
})();

